export default "__VITE_ASSET__CzzMjtSi__"